var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2858 22.3286C6.23829 22.3286 2.95716 19.0474 2.95715 15H4.75715C4.75716 18.0533 7.2324 20.5286 10.2858 20.5286L10.7143 20.5285C11.2113 20.5285 11.6143 20.9315 11.6143 21.4285C11.6143 21.9256 11.2114 22.3285 10.7143 22.3285L10.2858 22.3286Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6714 9.42857C13.6714 8.93151 14.0744 8.52857 14.5714 8.52857C16.4593 8.52857 18.1166 9.52478 19.0235 11.0187C19.2814 11.4436 19.1461 11.9971 18.7212 12.255C18.2963 12.513 17.7428 12.3776 17.4848 11.9528C16.8959 10.9826 15.8143 10.3286 14.5714 10.3286C14.0744 10.3286 13.6714 9.92563 13.6714 9.42857Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39084 3.89999C6.70996 3.89999 6.17524 4.48322 6.23423 5.16155L6.77119 11.3366L4.99862 11.7302L4.44099 5.31748C4.29056 3.58748 5.65431 2.09999 7.39084 2.09999C8.74954 2.09999 9.93389 3.0247 10.2634 4.34283L11.1589 7.92456C11.2794 8.40678 10.9862 8.89542 10.504 9.01597C10.0218 9.13653 9.53315 8.84334 9.4126 8.36113L8.51716 4.77939C8.38795 4.26256 7.92358 3.89999 7.39084 3.89999Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3952 3.47006C12.7704 3.33123 12.1522 3.72794 12.0181 4.35371L11.1657 8.33141C11.0616 8.81744 10.5832 9.12701 10.0971 9.02286C9.61113 8.91871 9.30155 8.44028 9.4057 7.95426L10.2581 3.97656C10.6016 2.37353 12.1853 1.35729 13.7856 1.71293C15.2814 2.04531 16.2743 3.46664 16.0718 4.98544L15.4635 9.5475C15.3979 10.0402 14.9452 10.3864 14.4525 10.3207C13.9598 10.255 13.6136 9.8023 13.6793 9.30961L14.2876 4.74754C14.3667 4.15465 13.979 3.59982 13.3952 3.47006Z",
    fill: "#023F80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79169 12.6399C9.6669 12.0783 9.1509 11.6919 8.5769 11.7302L7.76562 11.7843C6.07267 11.8971 4.75715 13.3033 4.75715 15H2.95715C2.95715 12.3556 5.0074 10.1642 7.64589 9.98827L8.45717 9.93418C9.918 9.83679 11.2312 10.8202 11.5488 12.2494C11.9176 13.9088 10.8186 15.5379 9.14185 15.8173L8.7194 15.8877C8.22911 15.9695 7.7654 15.6382 7.68368 15.1479C7.60197 14.6577 7.93319 14.194 8.42348 14.1122L8.84593 14.0418C9.50476 13.932 9.93658 13.2919 9.79169 12.6399Z",
    fill: "#023F80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6909 17.5351L15.3952 15.0367V20.0336L19.6909 17.5351ZM21.1129 19.0218C22.2511 18.3598 22.2511 16.7105 21.1129 16.0485L15.9661 13.0551C14.8246 12.3911 13.3952 13.2177 13.3952 14.5417V20.5286C13.3952 21.8526 14.8246 22.6791 15.9661 22.0152L21.1129 19.0218Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipOutline);
export default __webpack_public_path__ + "static/media/clip_outline.ce934e04e7e6710a4b3fe6f0d89de5bd.svg";
export { ForwardRef as ReactComponent };